import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgT5 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 60 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 26)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M44.799-1a2 2 0 011.417.59h0l8.731 10.493 1.087 5.051.018 6.866a1.997 1.997 0 01-1.833 1.993h0l-1.317.004a7.49 7.49 0 01-2.256 4.008A7.474 7.474 0 0145.552 30a7.474 7.474 0 01-5.094-1.995A7.49 7.49 0 0138.202 24h0-19.3a7.49 7.49 0 01-2.256 4.005A7.474 7.474 0 0111.552 30a7.474 7.474 0 01-5.094-1.995A7.49 7.49 0 014.202 24h0-3.153a1.997 1.997 0 01-1.993-1.83h0L-1 1.001A1.996 1.996 0 01.835-.993h0z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.052 0v8h13v2h-13a2 2 0 01-2-2V0h2z",
				fill: "#0D0E10"
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 11.552,
				cy: 22.5,
				r: 2.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 45.552,
				cy: 22.5,
				r: 2.5
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0D0E10",
				x: 2.052,
				y: 2,
				width: 2,
				height: 16,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0D0E10",
				x: 56.052,
				y: 16,
				width: 2,
				height: 4,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#0D0E10",
				strokeWidth: 2,
				strokeLinejoin: "round",
				d: "M24.004-1h10V9h-10zM10.004-1h10V9h-10z"
			})
		]
	})
});
export default SvgT5;
